
<div class="p-grid" style="margin:15px" >

    <div class="p-col-12" ngStickyNav>
        <!-- DETAILS MODERATION -->
        <p-panel [toggleable]="false" [showHeader]="true" class="p-col-12" styleClass="details">
            <p-header>DETAILS DE LA MODERATION</p-header>
            <div class="p-grid">
                <div class="p-col-4" style="text-align: center;">
                    Num point d'accueil : {{detailsPtl['num_point_accueil']}}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    Identifiant Bon Plan : {{detailsPtl['id_bon_plan']}}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    MODERATEUR : {{detailsPtl['operateur']}}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    ETAT : {{ detailsPtl["etat"] }}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    COMPLEXITE : {{ detailsPtl['libelle_complexite'] }}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    TYPE : {{ detailsPtl["type_ptl"] }}
                </div>
                
            </div>
        </p-panel>
        <!-- FIN DETAILS MODERATION -->

        <!-- DEBUT TOOLBAR PAUSE -->      
        <p-toolbar class=" toolbar">
            <div class="ui-toolbar-group-left">
                <!-- <p-button  type="button" [disabled]="pause" icon="pi pi-pause" label="Pause" class="btn-pause" (click)="beginPause()"></p-button> -->
                <span style="visibility: hidden;">
                    <strong>TEMPS PASSE : </strong> <b [chronometer]="chrono" [chronoEvents]="true" (onChronoEvent)="onChronoEvent($event)"></b>
                </span>
                <span style="font-size: x-large; color: #423a39ba;">
                    ENSEIGNE : {{ detailsPtl["enseigne_guide"] }}
                </span>
                <span>
                    <button pButton type="button" [disabled]="disabled" class="enseigne-guide-btn" icon="pi pi-external-link" iconPos="right" (click)="verifierEnseigne()"></button>
                </span>
            </div>
        
            <div class="ui-toolbar-group-right" style="font-size: x-large; color: #423a39ba; margin : 7px; ">
                <strong>DMT : </strong>
                <span *ngIf="boolIsNegatif" style="color: tomato"> <b>- </b> <b [chronometer]="chronoNegatif"  [chronoEvents]="true" (onChronoEvent)="onChronoEventNegatif($event)"></b>
                 </span>
                  <countdown *ngIf="!boolIsNegatif" #cd [config]="config" ></countdown>
            </div>

                
        </p-toolbar>
        <!-- FIN TOOLBAR PAUSE -->
    </div>


        <!-- CONTENU TITRE BON PLAN -->
        <ng-template [ngIf]="titreBonPlan['id_contenu']">
            <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'">
                <p-header > Titre du bon plan </p-header>
                <div class="p-grid">
                    <app-description [type-contenu]="'titreBonPlan'" [attente-doute]="attenteDoute" [cq]="true" [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="titreBonPlan['numero_contenu']" [content]="titreBonPlan['valeur_contenu']" [doute]=" titreBonPlan['doute'] "   [erreurs]=" titreBonPlan['erreurs'] " [valide]="titreBonPlan['is_valid']"  [valide-cq]="titreBonPlan['is_valid_cq']"  [erreurs-cq]=" titreBonPlan['erreurs_cq'] " (validCqChangedEvent)="setValidationTitreBP($event, true)" (validChangedEvent)="setValidationTitreBP($event, false)" (erreursCqChangedEvent)="erreursTitreBPChanged($event, true)" (erreursChangedEvent)="erreursTitreBPChanged($event, false)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
                </div>
            </p-panel>
        </ng-template>
        <!-- FIN CONTENU TITRE BON PLAN -->
    
        <!-- CONTENU PHRASE d'ACCROCHE -->
        <ng-template [ngIf]="phraseAccroche['id_contenu']">
            <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" >
                <p-header > Phrase d'accroche </p-header>
                <div class="p-grid">
                    <app-description [type-contenu]="'phraseAccroche'" [attente-doute]="attenteDoute" [cq]="true" [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="phraseAccroche['numero_contenu']" [content]="phraseAccroche['valeur_contenu']" [doute]=" phraseAccroche['doute'] "   [erreurs]=" phraseAccroche['erreurs'] " [valide]="phraseAccroche['is_valid']"  [valide-cq]="phraseAccroche['is_valid_cq']"  [erreurs-cq]=" phraseAccroche['erreurs_cq'] " (validCqChangedEvent)="setValidationPhraseAccroche($event, true)" (validChangedEvent)="setValidationPhraseAccroche($event, false)" (erreursCqChangedEvent)="erreursPhraseAccrocheChanged($event, true)" (erreursChangedEvent)="erreursPhraseAccrocheChanged($event, false)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
                </div>
            </p-panel>
        </ng-template>
        <!-- FIN CONTENU PHRASE d'ACCROCHE -->
    
    
        <!-- CONTENU DETAIL -->
        <ng-template [ngIf]="detail['id_contenu']">
            <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" >
                <p-header > Détails du bon plan </p-header>
                <div class="p-grid">
                    <app-description [type-contenu]="'detail'" [is-retour]="getIfRetour()" [cq]="true" [id-moderation]="idModeration" [attente-doute]="attenteDoute" [numero-contenu]="detail['numero_contenu']" [content]="detail['valeur_contenu']" [doute]=" detail['doute'] "   [erreurs]=" detail['erreurs'] " [valide]="detail['is_valid']"  [valide-cq]="detail['is_valid_cq']"  [erreurs-cq]=" detail['erreurs_cq'] " (validCqChangedEvent)="setValidationDetail($event, true)" (validChangedEvent)="setValidationDetail($event, false)" (erreursCqChangedEvent)="erreursDetailChanged($event, true)" (erreursChangedEvent)="erreursDetailChanged($event, false)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
                </div>
            </p-panel>
        </ng-template>
        <!-- FIN CONTENU DETAIL -->

    <!-- CONTENU SITE WEB -->
    <p-panel *ngIf="siteWeb['id_contenu']"  [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Site web </p-header>
        <app-reseaux-sociaux [is-retour]="getIfRetour()" [id-moderation]="idModeration" [attente-doute]="attenteDoute" [doute]="siteWeb['doute']" [numero-contenu]="siteWeb['numero_contenu']" [cq]="true" [lien]="siteWeb['valeur_contenu']" [valide]="siteWeb['is_valid']" [is-site]="true" [erreurs]=" siteWeb['erreurs'] "  [valide-cq]=" siteWeb['is_valid_cq'] " [erreurs-cq]=" siteWeb['erreurs_cq'] " (validCqChangedEvent)="setURLValidity(true, $event, true)" (erreursCqChangedEvent)="setURLErrors(true, $event, true)"  (validChangedEvent)="setURLValidity(true, $event, false)" (erreursChangedEvent)="setURLErrors(true, $event, false)"  (douteEvent)="contenuDouteUpdated($event)" ></app-reseaux-sociaux>
    </p-panel>
    <!-- FIN CONTENU SITE WEB -->

    <!-- CONTENU LOGO -->
    <p-panel  [transitionOptions]="'160ms'"  *ngIf="logo['id_contenu']" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Logo </p-header>
        <app-photos [is-retour]="getIfRetour()" [site-web]="siteWeb['valeur_contenu']" [attente-doute]="attenteDoute" [id-moderation]="idModeration" [doute]="logo['doute']" [numero-contenu]="logo['numero_contenu']" [no-duplicate]="true" [cq]="true" [lien]="logo['valeur_contenu']" [valide]=" logo['is_valid'] " [is-logo]="true" [erreurs]=" logo['erreurs'] "  [valide-cq]=" logo['is_valid_cq'] "  [erreurs-cq]=" logo['erreurs_cq'] " (validCqChangedEvent)="setMediaValidity(true, $event, true)" (erreursCqChangedEvent)="setMediaErrors(true, $event, true)" (validChangedEvent)="setMediaValidity(true, $event, false)" (erreursChangedEvent)="setMediaErrors(true, $event, false)" (douteEvent)="contenuDouteUpdated($event)" ></app-photos>
    </p-panel>
    <!-- FIN CONTENU LOGO -->

    <!-- CONTENU RESEAUX SOCIAUX -->
    <p-panel *ngIf="reseauxSociaux.length > 0" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Réseaux sociaux </p-header>
        <app-reseaux-sociaux *ngFor="let rs of reseauxSociaux" [is-retour]="getIfRetour()" [attente-doute]="attenteDoute" [cq]="true" [doute]="rs['doute']" [id-moderation]="idModeration" [numero-contenu]="rs['numero_contenu']" [lien]="rs['valeur_contenu']" [valide]="rs['is_valid']" [id-contenu]="rs['id_contenu']" [erreurs]=" rs['erreurs'] "  [valide-cq]=" rs['is_valid_cq'] " [erreurs-cq]=" rs['erreurs_cq'] " (validCqChangedEvent)="setURLValidity(false, $event, true)" (erreursCqChangedEvent)="setURLErrors(false, $event, true)" (validChangedEvent)="setURLValidity(false, $event, false)" (erreursChangedEvent)="setURLErrors(false, $event, false)"  (douteEvent)="contenuDouteUpdated($event)" ></app-reseaux-sociaux>
    </p-panel>
    <!-- FIN CONTENU RESEAUX SOCIAUX -->


    <!-- CONTENU DESCRIPTION -->
    <ng-template [ngIf]="description['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'">
            <p-header > Description </p-header>
            <div class="p-grid">
                <app-description [is-retour]="getIfRetour()" [cq]="true" [attente-doute]="attenteDoute" [doute]="description['doute']" [id-moderation]="idModeration" [numero-contenu]="description['numero_contenu']" [erreurs]="description['erreurs']" [valide-cq]="description['is_valid_cq']" [content]="description['valeur_contenu']" [valide]="description['is_valid']" class="p-col-12" [erreurs-cq]=" description['erreurs_cq'] " (validCqChangedEvent)="setValidationDescription($event, true)" (validChangedEvent)="setValidationDescription($event, false)" (erreursCqChangedEvent)="erreursDescriptionChanged($event, true)" (erreursChangedEvent)="erreursDescriptionChanged($event, false)" (douteEvent)="contenuDouteUpdated($event)" ></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU DESCRIPTION -->
    
    <!-- CONTENU PHOTO -->
    <p-panel *ngIf="photos.length > 0" [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Photos </p-header>    
        <app-photos *ngFor="let photo of photos" [is-retour]="getIfRetour()" [attente-doute]="attenteDoute" [doute]="photo['doute']" [cq]="true" [id-moderation]="idModeration" [numero-contenu]="photo['numero_contenu']" [lien]="photo['valeur_contenu']" [valide]=" photo['is_valid'] " [id-contenu]=" photo['id_contenu'] " [erreurs-cq]=" photo['erreurs_cq'] " [erreurs]=" photo['erreurs'] "  [valide-cq]=" photo['is_valid_cq'] " (validCqChangedEvent)="setMediaValidity(false, $event, true)" (erreursCqChangedEvent)="setMediaErrors(false, $event, true)" (validChangedEvent)="setMediaValidity(false, $event, false)" (erreursChangedEvent)="setMediaErrors(false, $event, false)" (douteEvent)="contenuDouteUpdated($event)" ></app-photos>
        
    </p-panel>
    <!-- FIN CONTENU PHOTO -->

<!--
    <p-panel  [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Offre bon plan </p-header>
        <app-offre lien="https://images.unsplash.com/photo-1589831313792-01cad3ff41cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80" contenu="Appareil très bonne état année XXXX marque CANON à vendre ou à louer"></app-offre>
    </p-panel>
-->
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Enregistrer la modération" style="width: 100%;" icon="pi pi-save" iconPos="right" (click)="nextTraitement(9)"></button>
    </div>
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Envoyer un mail de doute" style="width: 100%; border-color: coral; background-color: coral;" icon="pi pi-exclamation-triangle" iconPos="right" (click)="showEditor()"></button>
    </div>
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Valider et quitter" style="width: 100%;" icon="pi pi-sign-out" iconPos="right" (click)="nextTraitement(5,true)"></button>
    </div>
    <div class="p-col-4">

    </div>
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Valider CQ" style="width: 100%;" icon="pi pi-check" iconPos="right" (click)="nextTraitement(5)"></button>
    </div>
    <!-- <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Annuler" class="ui-button-secondary" style="width: 100%;" (click)="annulerTraitement()"></button>
    </div> -->
</div>

<p-sidebar  [(visible)]="pause" [modal]="true" [showCloseIcon]="false" [fullScreen]="true" class="pause-modal p-form" [appendTo]="'body'" [blockScroll]="true">
    <div class="p-grid" style="padding-top: 350px;">
        <div class="p-col-12" style="text-align: center;">
            <strong>TEMPS PASSE : </strong> <b [chronometer]="chronoPause" ></b>
        </div>
        <div class="p-col-5"></div>
        <p-dropdown class="p-col-2" [style]=" {'width': '100%'} " [options]="pauseItem" [(ngModel)]="selectedPause" placeholder="Selectionnez une pause" [appendTo]="'body'" ></p-dropdown>
        <div class="p-col-5"></div>
        <div class="p-col-5"></div>
        <ng-template [ngIf]="!endPauseClickable()">
            <p-button class="p-col-2" type="button" [disabled]="endPauseClickable()" icon="pi pi-play" [style]=" {'width': '100%'} " label="Reprendre traitement" styleClass="btn-traiter" (onClick)="endPause()"></p-button>
        </ng-template>
    </div>
</p-sidebar>

<p-toast [styleClass]="'message'">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em; font-weight: bold; "></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>


<p-dialog  [(visible)]="showEmailEditor" [modal]="true" [style]=" {'width': '75vw'} " header="Envoyer un mail de doute" >
    <div class="p-grid">
        <div class="p-col-12">
           à : <input type="text" name="adresse" pInputText [(ngModel)]="receiverAdress" style="width: 50%;">
        </div>
        <div class="p-col-12">
            <strong>OBJET :</strong> {{mailObject}}
        </div>
        <div class="p-col-12">
            <p-editor [(ngModel)]="mailContent" [style]=" {'height': '350px'} ">

            </p-editor>
        </div>
    </div>
    <p-footer>
        <button pButton type="button" label="Envoyer" style="border-color: darkcyan; background-color: darkcyan;" icon="pi pi-envelope" iconPos="right" (click)="sendMail()" ></button>
    </p-footer>
</p-dialog>
